/** Recuperado del despliegue 2026-10-05. Conserva lógica y memoización originales. */
import {
  rec_JSXRuntime as JSXRuntime,
  rec_React as React,
  rec_ReactCompiler as ReactCompiler,
  rec_YZ as YZ,
  rec_ii as ii,
} from "../../runtime/index.jsx";
export function QrVinculacion(e) {
  let t = (0, ReactCompiler.c)(8),
    { qr: n } = e,
    [r, i] = (0, React.useState)(null),
    a,
    o;
  (t[0] === n
    ? ((a = t[1]), (o = t[2]))
    : ((a = () => {
        let e = !0;
        return (
          YZ.toDataURL(n, {
            width: 264,
            margin: 2,
          })
            .then((t) => {
              e && i(t);
            })
            .catch(() => {
              e && i(null);
            }),
          () => {
            e = !1;
          }
        );
      }),
      (o = [n]),
      (t[0] = n),
      (t[1] = a),
      (t[2] = o)),
    (0, React.useEffect)(a, o));
  let s;
  t[3] === r
    ? (s = t[4])
    : ((s = r ? (
        <img
          src={r}
          alt={`Código para vincular el teléfono`}
          width={264}
          height={264}
          className={`rounded-lg`}
        />
      ) : (
        <div
          className={`flex h-[264px] w-[264px] items-center justify-center`}
          children={(0, JSXRuntime.jsx)(ii, {
            className: `h-6 w-6 animate-spin text-(--text)`,
          })}
        />
      )),
      (t[3] = r),
      (t[4] = s));
  let c;
  t[5] === Symbol.for(`react.memo_cache_sentinel`)
    ? ((c = (
        <p
          className={`text-xs text-(--text)`}
          children={`En el teléfono del bot: WhatsApp → Dispositivos vinculados → Vincular un dispositivo, y escanea este código. WhatsApp lo cambia cada 20 segundos: si no lo lee, espera el siguiente sin cerrar la cámara.`}
        />
      )),
      (t[5] = c))
    : (c = t[5]);
  let l;
  return (
    t[6] === s
      ? (l = t[7])
      : ((l = (
          <div
            className={`flex flex-col items-center gap-2 rounded-xl border border-(--border) p-3 text-center`}
            children={[s, c]}
          />
        )),
        (t[6] = s),
        (t[7] = l)),
    l
  );
}
